import auth from '@/router/middlewares/auth.js';

export default [
  {
    path: '/media/:mediaID',
    component: () => import('@/pages/media/index.vue'),
    name: 'Content-Approval-Workspace',
    meta: {
      layout: 'AuthenticatedLayout',
      middleware: [auth]
    }
  }
];
